import { createReducer, on } from '@ngrx/store';
import * as timesheetActions from './timesheet.action';
import { timesheetState } from './timesheet.state';

const timesheetReducer = createReducer(
  timesheetState,
  on(timesheetActions.getTimesheetLogsSuccess, (state, action) => ({
    ...state,
    logs: action.payload,
  })),
  on(timesheetActions.getTimesheetLogsCancel, (state) => ({
    ...state,
    logs: [],
  })),
  on(timesheetActions.fileUploadAction, (state) => {
    return {
      ...state,
      files: {
        ...state.files,
        fileName: '',
        fileUrl: '',
        fileNames: [],
        fileUrls: [],
      },
    };
  }),
  on(timesheetActions.fileUploadSuccessAction, (state, action) => {
    const { fileName, fileUrl } = action.payload;
    return {
      ...state,
      files: {
        ...state.files,
        fileName,
        fileUrl,
      },
    };
  }),
  on(timesheetActions.cancelFileUploadAction, (state) => {
    return {
      ...state,
      files: {
        ...state.files,
        fileName: '',
        fileUrl: '',
        fileNames: [],
        fileUrls: [],
      },
    };
  }),
  on(timesheetActions.fileUploadFailedAction, (state) => {
    return {
      ...state,
      files: {
        ...state.files,
        fileName: '',
        fileUrl: '',
        fileNames: [],
        fileUrls: [],
      },
    };
  })
);

export default timesheetReducer;
